import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function ClientNurs() {
  return (
    <section className="p-100">
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              <span style={{ color: "#6D4FC1" }}>The Client</span> Had?
            </h2>
            <p>
              The client initially had the idea to build a product for the
              healthcare market that would solve an old problem and make it easy
              to connect nursing staff and patients.
            </p>
          </Col>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-md-1"
          >
            <StaticImage
              src="../../../images/case-studies/nurse-practition/tek_img_04.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={633}
              height={708}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientNurs;
